import axios from "@/utils/axios.js";

/**
 *
 * @param {object} parms cityId-城市ID、cusTel-搜索手机号、houseD-项目id、page-页码、size-每页条数
 */
export async function getCustomer(parms) {
  return await axios.post("/downline/getCustomer", parms);
}

/**
 * 获取客户详情
 * @param {string} id
 */
export async function getCustomerDetail(id) {
  return await axios.get(`/customer/listWxCustomFollow/${id}`);
}

/**
 * 获取项目
 * @param {string} cityId 城市id
 */
export async function getHouses(cityId) {
  const params = { cityId };
  return await axios.post("/custom/getHouses", params);
}
